// extracted by mini-css-extract-plugin
export default {"timerBarParent":"timerBarParent-A0Tfgy2b","timerBar":"timerBar-NjgQTqGy","active":"active-xaK9JXzb"};